import { SectionFeaturedLocations, TagFragment, ResponsiveImage, Video } from '~/graphql/fragments'

export const queryProject = /* GraphQL */ `
  ${TagFragment}
  ${ResponsiveImage}
  ${Video}

  ${SectionFeaturedLocations}

  query Project($locale: SiteLocale, $first: IntType = 100, $slug: String) {
    _allProjectsMeta {
      count
    }
    allProjects(first: $first) {
      slug
      title
      video {
        ...Video
      }
    }
    project(locale: $locale, filter: { slug: { eq: $slug } }) {
      _firstPublishedAt
      _publishedAt
      _updatedAt
      _seoMetaTags {
        ...TagFragment
      }
      _allSlugLocales {
        value
        locale
      }
      _allPublishTranslationLocales {
        value
        locale
      }
      __typename
      _modelApiKey
      createdAt
      id
      poster {
        alt
        url
        width
        height
        responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1920 }) {
          ...ResponsiveImage
        }
      }
      video {
        ...Video
      }
      title
      slug
      metadata
      tags
      html
      description
      blocks {
        __typename
        ...SectionFeaturedLocations
      }
      publishTranslation
      seoMetadata {
        noIndex
      }
    }
  }
`
